
export const AuthenticationLevels={
    OtpAuthenticated:'OtpAuthenticated',
    FullAuthenticated:'FullAuthenticated',
}